import React  from 'react';
import './App.css';
import './QuestionSample.css';
import QuestionSampleLang from './QuestionSampleLang.json';

import { useNavigate } from "react-router-dom";

class QuestionSampleNew extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			questionSampleText: "",
		};

		this.onKeyDown = this.onKeyDown.bind(this);
		this.onQuestionSampleTextChanged = this.onQuestionSampleTextChanged.bind(this);
		this.serverInsertQuestionSampleRecord = this.serverInsertQuestionSampleRecord.bind(this);
		this.onClickSaveButton = this.onClickSaveButton.bind(this);
		this.onClickCancelButton = this.onClickCancelButton.bind(this);
	}
	
	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}

	onQuestionSampleTextChanged(value) {
		this.setState({questionSampleText: value});
	}
	
	async serverInsertQuestionSampleRecord(questionSampleCategoryID, questionText) {
		
		if (questionSampleCategoryID === 0) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/insertquestionsamplerecord?questionsamplecategoryid=" + questionSampleCategoryID;
		url = url + "&questiontext=" + encodeURIComponent(questionText);
		
		const res = await fetch(url);
		await res.text();

		this.props.showToast(this.props.getLang(QuestionSampleLang, "newQuestionSampleCreated"));
		const navigate = this.props.navigate;
  		navigate("/samplequestions");
	}
		
	onClickSaveButton() {
		
		var questionSampleText = this.state.questionSampleText;
		if (questionSampleText === "") {
			this.props.showToast("Sample question cannot be empty");
			return;
		}

		var questionSampleCategoryID = this.props.questionSampleCategoryID;
		this.serverInsertQuestionSampleRecord(questionSampleCategoryID, questionSampleText);

		var title = "New sample question: " + questionSampleText;
		var changeJsonObj = {};
		changeJsonObj.section = "questionsample";
		changeJsonObj.operation = "new";
		changeJsonObj.value = questionSampleText;
		var changeJSON = JSON.stringify(changeJsonObj);
		this.props.serverInsertChangeLogRecord(title, changeJSON);
	}
	
	onClickCancelButton() {
		const navigate = this.props.navigate;
  		navigate("/samplequestions");
	}
	
	render() {		

		return (
			<div className="ViewContainer1">
				<div style={{height: "30px"}}></div>
				<div className="ViewTopTitle">{this.props.getLang(QuestionSampleLang, "newQuestionSample")}</div>
				<div className="ViewTopText">{this.props.getLang(QuestionSampleLang, "newQuestionSampleInfoText")}</div>

				<div style={{height: "30px"}}></div>
				<div className="ViewBlockContainer">
					<div style={{height: "15px"}}></div>
					<div className="ViewBlockTitle">{this.props.getLang(QuestionSampleLang, "questionInfo")}</div>
					<div style={{height: "20px"}}></div>
					<div className="ViewContainer2">
						<p></p>
						<fieldset className="QuestionSampleNewFieldset">
							<legend className="QuestionSampleNewQuestionSampleLegend">{this.props.getLang(QuestionSampleLang, "questionSample")}</legend> 
							<input
								className="QuestionSampleNewQuestionSampleInput" 
								id="questionSample" 
								type="text" 
								autoFocus={true}
								onChange={(event) => this.onQuestionSampleTextChanged(event.target.value)}
								onKeyDown={(event) => this.onKeyDown(event.keyCode)}
							/>
						</fieldset>
					</div>
					<div style={{height: "60px"}}></div>
					<div className="ViewContainerButtons">
						<div style={{width: "200px"}}></div>
						<button className="ViewCancelButton" onClick={this.onClickCancelButton}>{this.props.getLang(QuestionSampleLang, "cancel")}</button>
						<div style={{width: "20px"}}></div>
						<button className="ViewSaveButton" onClick={this.onClickSaveButton}>{this.props.getLang(QuestionSampleLang, "save")}</button>
					</div>
					<div style={{height: "50px"}}></div>
				</div>

				<div style={{height: "100px"}}></div>
			</div>
		);
	}
}

export default function QuestionSampleNewFunction(props) {
	const navigate = useNavigate();
	return <QuestionSampleNew {...props} navigate={navigate} />;
}

